import gql from 'graphql-tag';

export const ProjectFromNameQuery = gql`
  query ProjectFromName($projectName: String!, $entityName: String) {
    project(name: $projectName, entityName: $entityName) {
      id
      name
      entityName
    }
  }
`;
